import { Link } from "react-router";

interface ButtonProps {
  children: React.ReactNode;
  to?: string;
  href?: string;
  variant?: "outlined" | "filled";
  className?: string;
  type?: "button" | "submit";
  onClick?: () => void;
  disabled?: boolean;
}

export default function Button({
  children,
  to,
  href,
  variant = "outlined",
  className = "",
  type = "button",
  onClick,
  disabled = false,
}: ButtonProps) {
  const base =
    "inline-block px-10 py-4 rounded-sm text-xs tracking-[0.2em] uppercase font-body transition-all duration-500 cursor-pointer";
  const variants = {
    outlined:
      "border border-soft-charcoal text-soft-charcoal hover:border-fig hover:text-fig",
    filled:
      "bg-faded-terracotta text-parchment hover:bg-fig",
  };
  const classes = `${base} ${variants[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={`${classes}${disabled ? " opacity-50 pointer-events-none" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
